export enum GoogleAuthFields {
  Token = "token",
}

export interface GoogleAuthorizationRequest {
  [GoogleAuthFields.Token]: string;
}

// type GoogleAuthorizationRequest = {
//   token: string;
// };
